// extracted by mini-css-extract-plugin
module.exports = {"playerFullscreenButton":"HkWAAzG25g1n-6oi4aZ7x","fullscreen":"_2I3EBtE3FTGjeDx6gFPiUT","background":"_3QjNvKH6cQJmHBfBvnfYUu","mobile":"_16SlVKRVP9shIceXytWlIY"};